/**
 * Given an object it will return a protected version that object
 * @param object Object
 * @return Object
 */
export const protectObjectProxy = <T extends Record<string | symbol, any>>(
	object: T,
) => {
	return new Proxy(object, {
		// Will return any object/arrays as their own copies
		// elminating the ability to pollute items in the object
		get(obj, prop) {
			const value = obj[prop];
			if (typeof value === 'object') return JSON.parse(JSON.stringify(value));
			return value;
		},
		// No setting
		set(obj, prop, value) {
			return false;
		},
	});
};

export default protectObjectProxy;
